import { render, staticRenderFns } from "./TaskListAsCalendar.vue?vue&type=template&id=c145149c"
import script from "./TaskListAsCalendar.vue?vue&type=script&lang=js"
export * from "./TaskListAsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports